import { Component, ViewChild } from '@angular/core';
import { LoadingController, Nav, NavController, ToastController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';
import { GraphicPage } from '../cow_graphic/cow_graphic';
import { CowRegister } from '../cow_register/cow_register';

@Component({
  selector: 'page-cow-list',
  templateUrl: 'cow_list.html'
})
export class CowList {
  public farms = [];
  public farm: any;
  public items = [];
  public relationship = '1';

  public filteredItems = [];
  public pages : number = 4;
  public pageSize : number = 10;
  public pageNumber : number = 0;
  public currentIndex : number = 1;
  public pagesIndex : Array<number>;
  public pageStart : number = 1;
  public host: string = '';

  @ViewChild(Nav) nav: Nav;
  public loader;
  constructor(
    public navCtrl: NavController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    private loadingCtrl:LoadingController
    ) {}
    showToast1(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 3000,
        cssClass: "toast-unsuccess"
      });
      toast.present();
    }
    showToast(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 3000,
        cssClass: "toast-success"
      });
      toast.present();
    }
    ionViewDidLoad() {
      console.log('Radio check::::::=>', this.relationship)
      // console.log(RestProvider.HOST);
      this.host = RestProvider.HOST;
      this.showLoader();
      this.filteredItems = JSON.parse(localStorage.getItem('Cows')).cows;
      this.refreshItems();
      this.currentIndex = 1;
      this.pageStart = 1;
      this.pages = 4;
      this.pageNumber = parseInt(""+ (this.filteredItems.length / this.pageSize));
      if(this.filteredItems.length % this.pageSize != 0){
        this.pageNumber ++;
      }
      if(this.pageNumber  < this.pages){
            this.pages =  this.pageNumber;
      }
      this.refreshItems();
      console.log("this.pageNumber :  "+this.pageNumber);
      this.hideLoader();
    }
    
    ionViewDidEnter(): void {
      document.getElementById('mainmenu').style.visibility = 'visible';
      document.getElementById('backmenu').style.display = 'block';
      document.getElementById('mainHeader').style.display = 'block';
      document.getElementById('backFrom').innerText = '';
      this.data.currentTabName = 'Үхрийн жагсаалт';
    }
    Delete(id){
      this.showLoader();
      this.rest.DeleteCows(id).subscribe(res => {
        this.rest.Cows(this.data.farm_id).subscribe(res => {
          this.items = res.cows;
        })
        this.showToast('Амжилттай устлаа.');
        this.refreshItems();
        this.hideLoader();
      })
      this.refreshItems();
    }
    Update(id, cow_code){
      this.navCtrl.push(CowRegister, {
        cow_id: id,
        cow_code: cow_code
      });
    }
    Graphic(id, cow_code){
      this.navCtrl.push(GraphicPage, {
        id: id,
        cow_code: cow_code,
      });
    }

      // FilterByName(){
      //   this.filteredItems = [];
      //   if(this.inputName != ""){
      //         productList.forEach(element => {
      //             if(element.name.toUpperCase().indexOf(this.inputName.toUpperCase())>=0){
      //               this.filteredItems.push(element);
      //             }
      //         });
      //   }else{
      //       this.filteredItems = productList;
      //   }
      //   console.log(this.filteredItems);
      //   this.init();
      // }
      fillArray(): any{
        var obj = new Array();
        for(var index = this.pageStart; index< this.pageStart + this.pages; index ++) {
                    obj.push(index);
        }
        return obj;
      }
      refreshItems(){
        this.items = this.filteredItems.slice((this.currentIndex - 1)*this.pageSize, (this.currentIndex) * this.pageSize);
        this.pagesIndex =  this.fillArray();
      }
      prevPage(){
        if(this.currentIndex>1){
            this.currentIndex --;
        } 
        if(this.currentIndex < this.pageStart){
            this.pageStart = this.currentIndex;
        }
        this.refreshItems();
      }
      nextPage(){
        if(this.currentIndex < this.pageNumber){
              this.currentIndex ++;
        }
        if(this.currentIndex >= (this.pageStart + this.pages)){
            this.pageStart = this.currentIndex - this.pages + 1;
        }

        this.refreshItems();
      }
      setPage(index : number){
            this.currentIndex = index;
            this.refreshItems();
      }
      showLoader(content?: string) {
        if (this.loader) {
          this.loader.dismiss();
        }
        this.loader = this.loadingCtrl.create({ 
          content: content ? content : "Ачаалж байна..."
        })
        this.loader.present();
        this.loader.onDidDismiss(()=>{
          this.loader = null;
        })
      }
      hideLoader() {
          if(this.loader)
            this.loader.dismiss();
      }
}



// WEBPACK FOOTER //
// ./src/pages/cow_list/cow_list.ts